var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "global-account-panel__wrappers" } },
    [
      _vm.isExpanded
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.Close,
                  expression: "Close"
                }
              ],
              staticClass: "global-panel global-panel__left"
            },
            [
              _c("FocusLock", [
                _c("div", { staticClass: "global-panel__inner-scroll" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "close gds-button-circle gds-icon-close-small gds-secondary",
                      on: {
                        click: function($event) {
                          return _vm.Close()
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "gds-visibility--hide-visually" },
                        [_vm._v("Close")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "gds-display-2 gds-space-stack-m" }, [
                    _vm._v("Switch Account")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "gds-space-stack-l" }, [
                    _vm._v("Select the account you'd like to view.")
                  ]),
                  _vm._v(" "),
                  _vm.isAdmin || _vm.isAdminLite
                    ? _c(
                        "div",
                        { staticClass: "gds-space-stack-l" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "global-panel__account-type-header gds-font-demi gds-text-grey"
                            },
                            [_vm._v("Account Ghosting")]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.ghostAccounts, function(account) {
                            return _c(
                              "div",
                              {
                                key: account.accountNumber,
                                staticClass: "global-panel__account-row",
                                attrs: { tabindex: "0" },
                                on: {
                                  click: function($event) {
                                    return _vm.SelectAccount(account)
                                  },
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.SelectAccount(account)
                                  }
                                }
                              },
                              [
                                account.photoUrl
                                  ? _c("div", {
                                      staticClass: "small-round-img",
                                      style: {
                                        backgroundImage:
                                          "url(" +
                                          _vm.GetResizedAccountPhoto(
                                            account.photoUrl
                                          ) +
                                          ")"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                !account.photoUrl
                                  ? _c("div", {
                                      staticClass: "small-round-img"
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "gds-display-0 gds-space-stack-s"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm._f("accountName")(account))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "gds-linebreaks" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("addressFormat")(
                                          account.address,
                                          { separator: "\n", skipFirst: true }
                                        )
                                      )
                                    )
                                  ])
                                ])
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "global-panel__account-link" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "gds-display-0 gds-link gds-link--bold",
                                  attrs: { href: "/admin/ghosting" }
                                },
                                [_vm._v("Search Accounts")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.ghostAccounts && _vm.ghostAccounts.length > 0
                            ? _c(
                                "div",
                                { staticClass: "global-panel__account-link" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "gds-button gds-text-button",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.ClearRecent()
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "gds-button__text" },
                                        [_vm._v("Clear Recent Searches")]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isAdmin && !_vm.isAdminLite
                    ? _c(
                        "div",
                        { staticClass: "gds-space-stack-m" },
                        [
                          _vm._l(_vm.accounts, function(account) {
                            return _c(
                              "div",
                              {
                                key: account.accountNumber,
                                staticClass: "global-panel__account-row",
                                attrs: { tabindex: "0" },
                                on: {
                                  click: function($event) {
                                    return _vm.SelectAccount(account)
                                  },
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.SelectAccount(account)
                                  }
                                }
                              },
                              [
                                account.photoUrl
                                  ? _c("div", {
                                      staticClass: "small-round-img",
                                      style: {
                                        backgroundImage:
                                          "url(" +
                                          _vm.GetResizedAccountPhoto(
                                            account.photoUrl
                                          ) +
                                          ")"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                !account.photoUrl
                                  ? _c("div", {
                                      staticClass: "small-round-img"
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "gds-display-0 gds-space-stack-s"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm._f("accountName")(account))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "gds-linebreaks" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("addressFormat")(
                                          account.address,
                                          { separator: "\n", skipFirst: true }
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  account.isPrimary
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "global-panel__primary-badge"
                                        },
                                        [_vm._v("Primary")]
                                      )
                                    : _vm._e()
                                ])
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "global-panel__account-link" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "gds-display-0 gds-link gds-link--bold",
                                  attrs: { href: "/user-profile/accounts" }
                                },
                                [_vm._v("Add / Manage Accounts")]
                              )
                            ]
                          )
                        ],
                        2
                      )
                    : _vm._e()
                ])
              ])
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }